import React, { useState } from "react";

const GalleryArea = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const images = [
    "/img/property/1.jpg",
    "/img/property/2.jpg",
    "/img/property/3.jpg",
    "/img/property/4.jpg",
    "/img/property/5.jpg",
    "/img/property/6.jpg",
    "/img/property/7.jpg",
    "/img/property/8.jpg",
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedImage("");
  };

  return (
    <section className="space space-bottom">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
            <div className="title-area">
              <span className="sec-subtitle">Discover Our Collection</span>
              <h2 className="sec-title h1">A Visual Journey</h2>
            </div>
          </div>
        </div>

        <div className="destination-list mb-5">
          {images.slice(0, 4).map((image, index) => (
            <div
              key={index}
              className="destination-style3"
              style={{ backgroundImage: `url(${image})` }}
              onClick={() => handleImageClick(image)}
            ></div>
          ))}
        </div>

        <div className="destination-list">
          {images.slice(4, 8).map((image, index) => (
            <div
              key={index}
              className="destination-style3"
              style={{ backgroundImage: `url(${image})` }}
              onClick={() => handleImageClick(image)}
            ></div>
          ))}
        </div>
      </div>

      {modalOpen && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <img src={selectedImage} alt="Full size" />
          </div>
        </div>
      )}
    </section>
  );
};

export default GalleryArea;
